import React from 'react'
import PageList from '../../../components/PageListAPI'
import { getAccountsTListAPI } from '../../../api/tariff.api'
import { useHistory, useLocation } from 'react-router-dom'

export default function AccountList() {
  const location = useLocation()
  const history = useHistory()
  return <div className='App-paper'>
    <PageList
      name='account-list'
      title='Список аккаунтов'
      columns={[
        { id: 'name', name: 'Аккаунт' },
        { id: 'shortName', name: 'Компания' },
        { id: 'inn', name: 'ИНН' },
      ]}
      createItem={true}
      deleteItem={false}
      loadAPI={{
        request: getAccountsTListAPI,
      }}
      location={location}
      history={history}
    />
  </div>
}